import { CatmullRomCurve3, Path, Shape, Vector3 } from 'three'
import { CaixaArredondada } from '../componentes/CaixaArredondada'

// Silhuetas nativas, sem texturas: corpo longitudinal e empunhadura traseira em D.
const cabo = new Shape()
cabo.moveTo(-0.075, 0.72)
cabo.lineTo(0.035, 0.72)
cabo.bezierCurveTo(0.13, 0.75, 0.23, 0.82, 0.23, 0.88)
cabo.lineTo(0.23, 1.01)
cabo.quadraticCurveTo(0.23, 1.055, 0.18, 1.055)
cabo.lineTo(-0.02, 1.055)
cabo.quadraticCurveTo(-0.075, 1.055, -0.075, 0.99)
cabo.closePath()
const abertura = new Path()
abertura.moveTo(-0.02, 0.81)
abertura.lineTo(-0.02, 0.98)
abertura.quadraticCurveTo(-0.02, 1.003, 0.01, 1.003)
abertura.lineTo(0.15, 1.003)
abertura.quadraticCurveTo(0.17, 1.003, 0.17, 0.98)
abertura.lineTo(0.17, 0.88)
abertura.quadraticCurveTo(0.17, 0.845, 0.035, 0.81)
abertura.closePath()
cabo.holes.push(abertura)

const lamina = new Shape()
lamina.moveTo(-0.024, 0.34)
lamina.lineTo(-0.024, 0.045)
lamina.lineTo(-0.010, 0)
lamina.lineTo(0.016, 0.018)
for (let i = 0; i < 24; i++) {
  const y = 0.018 + i * 0.012
  lamina.lineTo(0.025, y + 0.004)
  lamina.lineTo(0.016, y + 0.012)
}
lamina.lineTo(0.016, 0.34)
lamina.closePath()

const fio = new CatmullRomCurve3([
  new Vector3(-0.04, 1.06, 0), new Vector3(-0.055, 1.12, 0),
  new Vector3(-0.12, 1.15, -0.01), new Vector3(-0.16, 1.20, -0.02),
])

/** Ponta em Y=0; somente a lâmina e o encaixe fazem o movimento alternado. */
export function SerraSabre3D({ progresso }: { progresso: number }) {
  const curso = Math.sin(progresso * Math.PI * 50) * 0.012
  return <group name="serra-sabre-corte-vidro">
    <group position={[0, curso, 0]} name="lamina-reciprocante">
      <mesh position={[0, 0, -0.003]}>
        <extrudeGeometry args={[lamina, { depth: 0.006, bevelEnabled: false }]} />
        <meshStandardMaterial color="#242a30" metalness={0.85} roughness={0.3} />
      </mesh>
      <mesh position={[0, 0.345, 0]}><cylinderGeometry args={[0.022, 0.017, 0.06, 12]} /><meshStandardMaterial color="#a8b0ba" metalness={0.9} roughness={0.25} /></mesh>
    </group>
    {/* Sapata metálica vazada: a lâmina passa entre as duas abas. */}
    {[-1, 1].map((s) => <group key={`sapata:${s}`}>
      <mesh position={[s * 0.064, 0.325, 0]}><CaixaArredondada args={[0.018, 0.018, 0.15]} /><meshStandardMaterial color="#8793a0" metalness={0.85} roughness={0.3} /></mesh>
      <mesh position={[s * 0.057, 0.35, 0.06]} rotation={[0, 0, s * 0.25]}><CaixaArredondada args={[0.018, 0.07, 0.022]} /><meshStandardMaterial color="#687582" metalness={0.85} roughness={0.3} /></mesh>
    </group>)}
    <mesh position={[0, 0.325, -0.065]}><CaixaArredondada args={[0.14, 0.018, 0.02]} /><meshStandardMaterial color="#8793a0" metalness={0.85} roughness={0.3} /></mesh>
    <mesh position={[0, 0.39, 0]}><cylinderGeometry args={[0.066, 0.046, 0.075, 16]} /><meshStandardMaterial color="#343b43" metalness={0.65} roughness={0.35} /></mesh>
    {/* Revestimento frontal preto com nervuras de borracha. */}
    <mesh position={[0, 0.495, 0]} scale={[1, 1, 0.85]}><cylinderGeometry args={[0.098, 0.066, 0.19, 20]} /><meshStandardMaterial color="#171b20" roughness={0.8} /></mesh>
    {Array.from({ length: 6 }, (_, i) => <mesh key={`nervura:${i}`} position={[0, 0.43 + i * 0.025, 0]} rotation={[Math.PI / 2, 0, 0]} scale={[1, 0.85, 1]}>
      <torusGeometry args={[0.074 + i * 0.004, 0.0035, 4, 20]} /><meshStandardMaterial color="#30363e" roughness={0.85} />
    </mesh>)}
    <mesh position={[0, 0.665, 0]} scale={[0.105, 0.16, 0.088]}><sphereGeometry args={[1, 20, 14]} /><meshStandardMaterial color="#b9232c" roughness={0.45} /></mesh>
    <mesh position={[0, 0.592, 0]}><cylinderGeometry args={[0.104, 0.096, 0.035, 20]} /><meshStandardMaterial color="#de3340" roughness={0.45} /></mesh>
    <mesh position={[0, 0, -0.039]}>
      <extrudeGeometry args={[cabo, { depth: 0.078, bevelEnabled: true, bevelThickness: 0.008, bevelSize: 0.008, bevelSegments: 2, curveSegments: 12 }]} />
      <meshStandardMaterial color="#c32b34" roughness={0.5} />
    </mesh>
    <mesh position={[0.222, 0.957, 0]} rotation={[0, 0, -0.06]}><CaixaArredondada args={[0.025, 0.13, 0.088]} /><meshStandardMaterial color="#161a1e" roughness={0.85} /></mesh>
    <mesh position={[0.178, 0.93, 0]}><CaixaArredondada args={[0.022, 0.08, 0.045]} /><meshStandardMaterial color="#11151a" roughness={0.75} /></mesh>
    <mesh position={[0.075, 1.052, 0]}><CaixaArredondada args={[0.16, 0.016, 0.09]} /><meshStandardMaterial color="#252b31" roughness={0.8} /></mesh>
    {[-1, 1].flatMap((s) => Array.from({ length: 5 }, (_, i) => <mesh key={`ventilacao:${s}:${i}`} position={[-0.02 + i * 0.012, 0.708, s * 0.079]} rotation={[0, 0, -0.25]}>
      <CaixaArredondada args={[0.004, 0.035, 0.003]} /><meshStandardMaterial color="#45151b" roughness={0.7} />
    </mesh>))}
    {[-1, 1].flatMap((s) => [0.81, 1.017].map((y) => <mesh key={`parafuso:${s}:${y}`} position={[y < 0.9 ? -0.055 : 0.19, y, s * 0.047]} rotation={[Math.PI / 2, 0, 0]}>
      <cylinderGeometry args={[0.008, 0.008, 0.004, 8]} /><meshStandardMaterial color="#4c535d" metalness={0.8} roughness={0.3} />
    </mesh>))}
    <mesh><tubeGeometry args={[fio, 12, 0.009, 6, false]} /><meshStandardMaterial color="#181c22" roughness={0.85} /></mesh>
  </group>
}
